const RootPath = window.g.baseUrl
const apis = {
  // 根据产品类别ID获取产品列表
  getStoreProducts: RootPath + 'plugin/app/default/GetProducts',
  // 根据选择的产品，获取对应的页码和品番
  getStorePageCodes: RootPath + 'plugin/app/default/GetPageCodes',
  // 根据选择的产品和页码，获取响应的品番
  getDesignations: RootPath + 'plugin/app/default/GetDesignations',
  // 获取库位
  getStorageLocations: RootPath + 'plugin/app/default/GetStorageLocations',
  // 出库
  outBound: RootPath + 'plugin/app/default/SaveOutbound'
}

export default apis
